module.exports = __webpack_public_path__ + "img/bc-favork.23bb8bf3.png";